import { FC, useContext } from "react";

import { UserContext } from "@/model/User/UserContext";

import { checkAdminAccess } from "@/service/ApplicationQueries";

export const AdminProtected: FC = (props) => {
  const user = useContext(UserContext);

  return <>{user && checkAdminAccess(user) ? props.children : null}</>;
};
